module.exports = __webpack_public_path__ + "static/img/empty.31c8898e.png";